export default __webpack_public_path__ + "static/media/character_02.1cce84a1.png";